<template>
    <div class="page__column">
        <ul class="price price_free" v-if="$mq==='desktop'">
            <li class="price__item price__item_free">
                <div class="price__header">
                    <i class="price__icon icon icon_heart-white"></i>
                    <h3 class="price__title">Free trial</h3>
                </div>
                <div class="price__body">
                    <div class="price__description">
                        <span class="price__label">Free</span>
                        <span class="price__value"><span>$</span>200.00</span>
                        <span class="price__credit">{{Number(+tariff.bonus + (+tariff.amount)).toFixed(0)}} credits</span>
                    </div>
                    <ul class="price__features list">
                        <li  class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>VIP Profile</span>
                        </li>
                        <li class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>Profile top promotion</span></li>
                        <li class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>Personal Chat Assistant</span>
                        </li>
                        <li class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>No message limits</span>
                        </li>
                        <li class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>{{Number(tariff.bonus).toFixed(0)}} Bonus credits</span>
                        </li>
                    </ul>
                    <button class="button button_sm button_primary price__button" @click.prevent="select">
                        <span>Select</span>
                    </button>
                </div>
            </li>
        </ul>
        <ul class="price price_mobile price_free" v-else>
            <li class="price__tab price__item price__item_free">
                <input type="checkbox" id="free" checked="checked">
                <label class="price__tab-label" for="free">
              <span class="price__header">
                  <i class="price__icon icon icon_heart-white"></i>
                  <span class="price__title">Free trial</span>
              </span>
                    <span class="price__description">
                    <span class="price__label">Free</span>
                  <span class="price__value"><span>$</span>200.00</span>
                  <span class="price__credit">{{Number(+tariff.bonus + (+tariff.amount)).toFixed(0)}} credits</span>
              </span>
                </label>
                <div class="price__tab-content">
                    <ul class="price__features list">
                        <li  class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>VIP Profile</span>
                        </li>
                        <li class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>Profile top promotion</span></li>
                        <li class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>Personal Chat Assistant</span>
                        </li>
                        <li class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>No message limits</span>
                        </li>
                        <li class="list__item">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                                 fill="none" class="svg-icon">
                                <path data-v-64671521="" fill="currentColor"
                                      d="m11.1599 2.11979-5.51998 7.2c-.24.24-.6.48-.96.48s-.72-.12-.96-.48l-2.88-3.72c-.36-.48-.36-1.32.24-1.68.6-.36 1.32-.36 1.68.24l1.92 2.52 4.56-6c.36-.48 1.19998-.6 1.67998-.24.6.36.6 1.08.24 1.68Z"></path>
                            </svg>
                            <span>{{Number(tariff.bonus).toFixed(0)}} Bonus credits</span>
                        </li>
                    </ul>
                    <button class="button button_sm button_primary price__button" @click.prevent="select">
                        <span>Select</span>
                    </button>
                </div>
            </li>
        </ul>

        <section-payment-page :init-show-list="true" v-if="$mq==='desktop'"></section-payment-page>
    </div>
</template>
<script>
import SectionPaymentPage from "./SectionPaymentPage.vue";
import PriceFeaturesList from "./PriceFeaturesList.vue";

export default {
    name: "FreePayment",
    props: ['tariff','holidayPromotion'],
    components: {
        PriceFeaturesList,
        SectionPaymentPage
    },
    methods:{
        select(){
            console.log()
            this.$emit('go_free_payment');
            this.sendEventFbq();
        },
        sendEventFbq(){
            try {
                fbq('track', 'StartTrial', {
                    value: 0.00,
                    currency: 'USD',
                });
            }catch(err){
                console.error(err)
            }
        },
        getBonus(amount, bonus){
            if(this.holidayPromotion && this.holidayPromotion.bonuses){
                return this.holidayPromotion.bonuses[amount] ? this.holidayPromotion.bonuses[amount] : 0
            }
            return bonus;
        }
    }
}
</script>

<style scoped>

</style>
